module.exports = __webpack_public_path__ + "static/feature2-ff7e70793a60330b0308323485880107.mp4";